export enum PaymentDivideType {
  'TICKET' = 'P0200001',
  'BOOTH' = 'P0200002',
}
